// extracted by mini-css-extract-plugin
export default {"input":"style_input__A36eO","label":"style_label__UJZuU","textarea":"style_textarea__9ExAh"};